module.exports = "/images/artworks-CTA.jpg?332475c69b2c18a9a9acc114b8a1bff1";